import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { makeStyles, useTheme } from '@mui/styles';

import { indigo, grey, orange, blue } from '@mui/material/colors';
import { useSnackbar } from "notistack";
import PF from "../_Services/publicFunction";
import { useForm, Controller } from "react-hook-form";
import Qs from "qs";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../reducers/app";
import CryptoJS from "crypto-js";
import AES from 'crypto-js/aes';
import encUtf8 from 'crypto-js/enc-utf8';
import pic from '../Pictures/127.mp4'
function Copyright(props) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="http://www.grandbridgenet.com/">
                嵩橋科技軟件
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();
const useStyles = makeStyles((theme) => ({
    root: {
        padding: 0,
        '&:first-child ': {
            padding: 0,
        }
    },
    appBar: {
        position: 'relative',
        backgroundColor: indigo[500],
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    button: {
        // borderRight: "3px solid transparent",
        "&:hover": {
            // borderRightColor: "blue",
            // borderRight: "3px solid",
            filter: "brightness(120%)",
        },
        "&:focus": {
            borderRightColor: "blue",
            borderRight: "3px solid",
        }
    }
}));

export default function SignInSide() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { enqueueSnackbar } = useSnackbar();
    const { register, formState: { errors }, handleSubmit, formState, control, onBlur, onChange } = useForm();

    const [user, setUser] = React.useState({ PersonalId: "", Password: "" })
    const handleTxtChange = e => {
        const { name, value } = e.target;
        setUser(prevstate => ({
            ...prevstate,
            [name]: value.trim()
        }));
        // console.log(name, value)
    }
    const { PersonalIdref, ...PersonalIdinputProps } = register("PersonalId", {
        required: { value: true, message: "必須" },
        pattern: { value: /^[A-Za-z.]+$/, message: "非字母" },// 正则表达式，只允许字母输入
        //  pattern: { value: /^[^0-9]+$/, message: "非數字" },
        onChange: handleTxtChange
    });
    const { Passwordref, ...PasswordinputProps } = register("Password", {
        required: { value: true, message: "必須" },
        //  pattern: { value: /^[^0-9]+$/, message: "非數字" },
        onChange: handleTxtChange
    });
    const onSubmit = (event) => {
        // event.preventDefault();
        // const data = new FormData(event.currentTarget);
        // console.log(user);
        // console.log({
        //     email: data.get('email'),
        //     password: data.get('password'),
        // });
        PF.instance({
            method: "post",
            url: PF.url2 + "/Minmax/UserLogin",
            data: Qs.stringify({
                Action: "1",
                parameter: {
                    username: user.PersonalId,
                    password: user.Password
                }
            }),
        })
            .then(function (response) {

                const { TotalRecord, rows, Token } = response.data
                if (TotalRecord <= 0) {
                    // alert("問卷提交出錯\r\n" + ErrorMessage + "請致電 04-2255-2555 #168 企業健檢")
                    enqueueSnackbar("帳號或密碼錯誤", { variant: "error", style: { whiteSpace: 'pre-line' } });
                } else {
                    enqueueSnackbar("登入成功", { variant: "success", style: { whiteSpace: 'pre-line' } });
                    dispatch(actions.UserInfo(user));
                    dispatch(actions.TOKEN_SET(Token));

                    if (checked === true) {
                        localStorage.setItem("UserInfo", JSON.stringify({ PersonalId: user.PersonalId, Password: AES.encrypt(user.Password, '加密密碼').toString() }));
                        localStorage.setItem("token", Token);
                    }
                    navigate(`/MinmaxQuery`)

                }
            })


    };
    const classes = useStyles();
    const handleForget = () => {
        enqueueSnackbar("呆子...", { variant: "error", style: { whiteSpace: 'pre-line' } });

    }
    const [checked, setChecked] = React.useState(true);
    const handleChkChange = event => {
        setChecked(event.target.checked);
    }
    return (
        <ThemeProvider theme={defaultTheme}>

            <Grid container component="main" sx={{}}>
                <CssBaseline />
                <Grid
                    item
                    xs={false}
                    sm={4}
                    md={6}
                    sx={{
                        // backgroundImage: 'url(https://source.unsplash.com/random?wallpapers)',
                        backgroundImage: pic,
                        backgroundRepeat: 'no-repeat',
                        backgroundColor: (t) =>
                            t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',

                    }}
                    className={classes.button}
                >
                    <video autoPlay muted loop style={{
                        height: "auto", backgroundSize: 'cover', width: "100vw", backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center', position: 'fixed', zIndex: 1
                    }}>
                        <source src={pic} ></source>
                    </video>
                </Grid>
                <Grid item xs={12} sm={8} md={6} component={Paper} elevation={6} square sx={{ zIndex: 0, height: '100vh', "&:hover": { zIndex: 3 } }}>
                    <Box
                        sx={{
                            my: 8,
                            mx: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                            <LockOutlinedIcon />
                        </Avatar>
                        <Typography component="h1" variant="h5">
                            Sign in
                        </Typography>
                        <Box component="form" noValidate onSubmit={handleSubmit(onSubmit)} sx={{ mt: 1 }}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="PersonalId"
                                label="User name"
                                name="PersonalId"
                                autoComplete="username"
                                autoFocus
                                onChange={handleTxtChange}
                                value={user.username}
                                error={!!errors.PersonalId}
                                helperText={errors?.PersonalId?.message}
                                inputRef={PersonalIdref}
                                {...PersonalIdinputProps}

                            />
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="Password"
                                label="Password"
                                type="Password"
                                id="Password"
                                autoComplete="current-password"
                                onChange={handleTxtChange}
                                value={user.password}
                                error={!!errors.Password}
                                helperText={errors?.Password?.message}
                                inputRef={Passwordref}
                                {...PasswordinputProps}

                            />
                            <FormControlLabel
                                control={<Checkbox checked={checked} value="remember" color="primary" onChange={handleChkChange} name={"remember"} />}
                                label="Remember me"
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}
                            >
                                Sign In
                            </Button>
                            <Grid container>
                                <Grid item xs>
                                    <Link href="#" variant="body2" onClick={handleForget}>
                                        Forgot password?
                                    </Link>
                                </Grid>
                                {/* <Grid item>
                                    <Link href="#" variant="body2">
                                        {"Don't have an account? Sign Up"}
                                    </Link>
                                </Grid> */}
                            </Grid>
                            <Copyright sx={{ mt: 5 }} />
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </ThemeProvider >
    );
}
